import { render } from "./LoadingBlock.vue?vue&type=template&id=c1655504"
import script from "./LoadingBlock.vue?vue&type=script&lang=js"
export * from "./LoadingBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__